var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Navbar'),_vm._v(" "),_c('Announcements'),_vm._v(" "),_c('NuxtChild'),_vm._v(" "),_c('FooterHero')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }